<div class="container-fluid">
  <div class="col-md-12">
    <div class="breadcrumb-title border-0 mb-3">
      <div class="d-flex justify-content-start align-items-center flex-wrap">
        <mat-icon color="primary">home</mat-icon>
        <p class="ms-2 mb-0">{{"APPCOMPONENT.MENU.DASHBOARD" | translate}}</p>
      </div>
    </div>
  </div>
  <app-app-info *ngIf="appInfoList" [appInfoList]="appInfoList" [appStorageInfoList]="appStorageInfoList">
  </app-app-info>
</div>